import React, { Fragment, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { useStudyPlan } from "../../app/contexts/study.context";
import { useUser } from "../../app/contexts/user.context";
import ViewSiteListModal from "./ViewSiteListModal";
import PrimaryButton from "../../app/components/buttons/primary";
import { checkRemodelRun, getRemodelUnavailableMessage } from "../../study.plan.actuals/study.actuals.utils";

const Controls = ({ search = "", onSearch, clearSearch }) => {
  const [remodelViewOpen, setRemodelViewOpen] = useState(false);
  const { studyActualsData, loadStudyActuals, lActualsLoading, study } = useStudyPlan();
  const { isReadOnlyUser } = useUser();
  const { actualsData = [] } = studyActualsData;
  const navigate = useNavigate();
  const { id } = useParams();
  const remodelUnavailableMessage = getRemodelUnavailableMessage(study?.studyPlans, {
    hasActualsData: actualsData.length > 0,
  });

  const handleRemodel = () => {
    navigate(`/ctpo/study-actuals/${id}/remodel`);
  };

  return (
    <Container>
      {actualsData.length > 0 ? (
        <Fragment>
          {lActualsLoading ? (
            <CircularProgress
              color="white"
              size="2em"
            />
          ) : (
            <Fragment>
              {remodelUnavailableMessage && (
                <Typography style={{ fontWeight: "600", alignSelf: "center" }}>
                  {remodelUnavailableMessage}
                </Typography>
              )}
              {!isReadOnlyUser && !remodelUnavailableMessage && (
                <PrimaryButton
                  disabled={checkRemodelRun(actualsData)}
                  onClick={handleRemodel}
                >
                  REMODEL
                </PrimaryButton>
              )}
              <PrimaryButton
                disabled={checkRemodelRun(actualsData)}
                onClick={() => setRemodelViewOpen(true)}
              >
                VIEW SITE LIST
              </PrimaryButton>
              <PrimaryButton onClick={loadStudyActuals}>
                IMPORT ACTUALS
              </PrimaryButton>

              <ViewSiteListModal
                remodelViewOpen={remodelViewOpen}
                setRemodelViewOpen={setRemodelViewOpen}
              />
            </Fragment>
          )}
        </Fragment>
      ) : (
        <div></div>
      )}
    </Container>
  );
};
export default Controls;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 1em 0;
  gap: 1em;
  align-content: center;
`;
